export default {
  path: '/',
  name: 'activities',
  hidden: false,
  meta: {
    title: '活动管理',
    icon: 'fa fa-dashboard iconTitle',
    nav: 'act',
    level: 1
  },
  component: resolve =>
    require(['@/views/Application.vue'], m => resolve(m.default)),
  children: [
    {
      path: '/illegal/:activityId',
      name: 'illegal',
      hidden: true,
      meta: {
        title: '违规处理',
        level: 2,
        nav: 'act',
        iconClass: 'icon-activities',
        role: ['admin', 'levelunion', 'topunion'],
        icon: 'fa fa-dashboard iconTitle'
      },
      component: () => import('@/views/illegal-view')
    },
    {
      path: '/matchList',
      name: 'matchList',
      hidden: false,
      meta: {
        title: '活动列表',
        level: 2,
        nav: 'act',
        iconClass: 'icon-activities',
        role: ['admin', 'levelunion', 'topunion'],
        icon: 'fa fa-dashboard iconTitle'
      },
      component: () => import('@/views/activitiesList')
    },
    // {
    //   path: '/nationalAssess',
    //   name: '评审库',
    //   hidden: false,
    //   meta: {
    //     title: '国家评委库',
    //     level: 2,
    //     nav: 'act',
    //     role: ['admin', 'topunion'],
    //     icon: 'fa fa-dashboard iconTitle'
    //   },
    //   component: () => import('@/views/compmanage/reviewlibrary')
    // },
    {
      path: '/assignMission/:id',
      name: '下达任务',
      hidden: true,
      meta: {
        title: '下达任务',
        nav: 'act',
        role: ['admin', 'topunion', 'levelunion']
      },
      component: resolve =>
        require(['@/views/compmanage/activity/assignMission'], m =>
          resolve(m.default))
    },
    {
      path: '/detilMission/:id',
      name: '查看任务',
      hidden: true,
      meta: {
        title: '查看任务',
        nav: 'act',
        role: ['admin', 'topunion', 'levelunion']
      },
      component: resolve =>
        require(['@/views/compmanage/activity/assignMission/detail'], m =>
          resolve(m.default))
    },
    {
      path: '/editMission/:id',
      name: '修改任务',
      hidden: true,
      meta: {
        title: '修改任务',
        nav: 'act',
        role: ['admin', 'topunion', 'levelunion']
      },
      component: resolve =>
        require([
          '@/views/compmanage/activity/assignMission/editMission.vue'
        ], m => resolve(m.default))
    },
    {
      path: '/createActivity',
      name: 'createdActivity',
      hidden: true,
      meta: { title: '创建活动', level: 3, nav: 'act' },
      component: resolve =>
        require([
          '@/views/compmanage/activity/createActivity/newIndex.vue'
        ], m => resolve(m.default))
    },
    {
      path: '/createActivity/:id',
      name: 'createdActivities',
      hidden: true,
      meta: { title: '创建活动', level: 3, nav: 'act' },
      component: resolve =>
        require([
          '@/views/compmanage/activity/createActivity/newIndex.vue'
        ], m => resolve(m.default))
    },
    {
      path: '/courseTimeSetting/:id',
      name: '决赛现场赛程设置',
      hidden: true,
      meta: { title: '决赛现场赛程设置', level: 3, nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/activity/CourseTimeSetting.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/activityDetails/:id',
      name: '活动详情',
      hidden: true,
      meta: { title: '活动详情', level: 4, nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/activity/ActivityDetails.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/participants/:id',
      name: '参赛者名单',
      hidden: true,
      meta: { title: '参赛者名单', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/participants/Participants.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/addParticipants',
      name: '添加参赛人员',
      hidden: true,
      meta: { title: '添加参赛人员', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/participants/AddParticipants.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/participantForm',
      name: '新建参赛人员',
      hidden: true,
      meta: { title: '新建参赛人员', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/participants/ParticipantForm.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/participantDetail/:id',
      name: '参赛人员详情',
      hidden: true,
      meta: { title: '参赛人员详情', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/participants/ParticipantInfo.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/StaffMember/:id/:activityId',
      name: '工作人员名单',
      hidden: true,
      meta: { title: '工作人员名单', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/staffmember/StaffMember.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/setUpload/:type/:id/:status',
      name: '竞赛材料设置',
      hidden: true,
      meta: { title: '竞赛材料设置', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/activity/UploadSetting.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/modifyMatchGrade/:id',
      name: '查看比赛成绩',
      hidden: true,
      meta: {
        title: '比赛结果',
        nav: 'act',
        role: ['admin', 'topunion', 'levelunion']
      },
      component: resolve =>
        require(['@/views/compmanage/manageMatch/ModifyGrade.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/matchReportUpload/:id',
      name: '上报比赛成绩',
      hidden: true,
      meta: { title: '上报比赛成绩', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/manageMatch/MatchReportUpload.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/drawLots/:id',
      name: 'drawlots',
      hidden: true,
      meta: { title: '抽取出场顺序', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/manageMatch/DrawLots.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/materialScoring/:id',
      name: '材料打分进度查看',
      hidden: true,
      meta: { title: '材料打分进度查看', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/manageMatch/MaterialScoring.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/drawCourseware/:id',
      name: '抽取课件',
      hidden: true,
      meta: { title: '抽取课件', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/manageMatch/DrawCourseware.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/leaderList/:id',
      name: '领队列表',
      hidden: true,
      meta: { title: '领队列表', nav: 'act' },
      component: resolve =>
        require(['@/views/leader/LeaderList.vue'], m => resolve(m.default))
    },
    {
      path: '/leaderDetails/:id/:activityId/:unionId',
      name: '领队详情',
      hidden: true,
      meta: { title: '领队详情', nav: 'act' },
      component: resolve =>
        require(['@/views/leader/LeaderDetails.vue'], m => resolve(m.default))
    },
    {
      path: '/enrollInfo/:id',
      name: '报名情况',
      hidden: true,
      meta: { title: '报名情况', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/enrollInfo/EnrollInfos.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/publishResult/:id',
      name: '发布结果',
      hidden: true,
      meta: { title: '发布结果', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/manageMatch/PublishResult.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/volunteers/:id',
      name: '志愿者',
      hidden: true,
      meta: { title: '志愿者', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/volunteers/Volunteers.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/notice/:activityId',
      name: '公告',
      hidden: true,
      meta: { title: '公告', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/notice/NoticeList.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/createNotice/:activityId',
      name: '新建公告',
      hidden: true,
      meta: { title: '新建公告', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/notice/CreateNotice.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/liveVideoControl',
      name: '直播控制',
      hidden: true,
      meta: { title: '直播控制', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/control/liveVideoControl.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/noticeDetail/:activityId',
      name: '公告详情',
      hidden: true,
      meta: { title: '公告详情', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/notice/NoticeDetail.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/progressManage/:id',
      name: 'progressManage',
      hidden: true,
      meta: {
        title: '活动进程',
        level: 3,
        nav: 'act'
      },
      component: resolve =>
        require(['@/views/compmanage/progressManage'], m => resolve(m.default))
    },
    {
      path: '/attachmentSetting',
      name: '附件设置',
      hidden: true,
      meta: { title: '附件设置', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/activity/attachmentSetting'], m =>
          resolve(m.default))
    },
    // {
    //   path: '/liveSetting',
    //   name: '公告详情',
    //   hidden: true,
    //   meta: { title: '公告详情' },
    //   component: resolve =>
    //     require(['@/views/compmanage/activity/liveSetting'], m => resolve(m.default))
    // },
    {
      path: '/checkResult',
      name: '查看结果',
      hidden: true,
      meta: { title: '查看结果', nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/activity/checkResult'], m =>
          resolve(m.default))
    },
    {
      path: '/matchSetting',
      name: '活动设置',
      hidden: true,
      meta: {
        title: '活动设置',
        nav: 'act'
      },
      component: resolve =>
        require(['@/views/compmanage/activity/match-setting'], m =>
          resolve(m.default)),
      redirect: '/matchBaseSetting',
      children: [
        {
          path: '/matchBaseSetting',
          name: '基本设置',
          hidden: true,
          meta: { title: '基本设置', level: 3, nav: 'act' },
          component: resolve =>
            require(['@/views/compmanage/activity/basicSetting'], m =>
              resolve(m.default))
        },
        {
          path: '/linkSetting',
          name: '活动环节设置',
          hidden: true,
          meta: { title: '活动环节设置', level: 3, nav: 'act' },
          component: resolve =>
            require(['@/views/compmanage/activity/linkSetting'], m =>
              resolve(m.default))
        },
        {
          path: '/activitySignUpSettings',
          name: '报名设置',
          hidden: true,
          meta: { title: '报名设置', level: 3, nav: 'act' },
          component: resolve =>
            require(['@/views/compmanage/activity/signupSetting'], m =>
              resolve(m.default))
        },
        {
          path: '/activityEditSettings',
          name: '报名表编辑',
          hidden: true,
          meta: { title: '报名表编辑', level: 3, nav: 'act' },
          component: resolve =>
            require(['@/views/compmanage/activity/editSetting'], m =>
              resolve(m.default))
        },
        {
          path: '/materialSetting',
          name: '材料设置',
          hidden: true,
          meta: { title: '材料设置', level: 3, nav: 'act' },
          component: resolve =>
            require(['@/views/compmanage/activity/materialSetting'], m =>
              resolve(m.default))
        },
        {
          path: '/matchLiveSetting',
          name: '现场比赛设置',
          hidden: true,
          meta: { title: '现场比赛设置', level: 3, nav: 'act' },
          component: resolve =>
            require(['@/views/compmanage/activity/liveSetting/index.vue'], m =>
              resolve(m.default))
        },
        {
          path: '/scoringSetting',
          name: '计分设置',
          hidden: true,
          meta: { title: '计分设置', level: 3, nav: 'act' },
          component: resolve =>
            require(['@/views/compmanage/activity/scoringSetting'], m =>
              resolve(m.default))
        }
      ]
    },
    {
      path: '/peopleManage',
      name: '人员管理',
      hidden: true,
      meta: {
        title: '人员管理',
        level: 4,
        nav: 'act'
      },
      component: () => import('@/views/compmanage/peopleManage'),
      children: [
        {
          path: 'worker/:id',
          name: '工作人员列表',
          hidden: true,
          meta: { title: '工作人员列表', level: 5, nav: 'act' },
          component: () => import('@/views/compmanage/peopleManage/sub/worker')
        },
        {
          path: 'judge/:id',
          name: '评委列表',
          hidden: true,
          meta: { title: '评委列表', level: 5, nav: 'act' },
          component: () => import('@/views/compmanage/peopleManage/sub/judge')
        },
        {
          path: 'player/:id',
          name: '参赛人员列表',
          hidden: true,
          meta: { title: '参赛人员列表', level: 5, nav: 'act' },
          component: () => import('@/views/compmanage/peopleManage/sub/player')
        },
        {
          path: 'teams/:id',
          name: '参赛队伍',
          hidden: true,
          meta: { title: '参赛队伍', level: 5, nav: 'act' },
          component: () => import('@/views/compmanage/peopleManage/sub/teams')
        },
        {
          path: 'volunteer/:id',
          name: '志愿者列表',
          hidden: true,
          meta: { title: '志愿者列表', level: 5, nav: 'act' },
          component: () =>
            import('@/views/compmanage/peopleManage/sub/volunteer')
        },
        {
          path: 'contractor/:id',
          name: '承办方账号',
          hidden: true,
          meta: { title: '承办方账号', level: 5, nav: 'act' },
          component: () =>
            import('@/views/compmanage/peopleManage/sub/contractor')
        },
        {
          path: 'teamDetail/:id/:unionId',
          name: '参赛队详情',
          hidden: true,
          meta: { title: '参赛队详情', hiddenNav: true, level: 6, nav: 'act' },
          component: () =>
            import('@/views/compmanage/peopleManage/teams-detail')
        },
        {
          path: 'leaderDetail',
          name: 'leaderDetail',
          hidden: true,
          meta: {
            title: '领队详情',
            hiddenNav: true,
            level: 7,
            nav: 'act'
          },
          component: () =>
            import(
              '@/views/compmanage/peopleManage/player-detail/leaderDetail.vue'
            )
        },
        {
          path: 'playerDetail/:activityId/:playerId/:groupId/:isRecommend?',
          name: 'playerDetail',
          hidden: true,
          meta: {
            title: '参赛人员详情',
            hiddenNav: true,
            level: 7,
            nav: 'act'
          },
          component: () =>
            import('@/views/compmanage/peopleManage/player-detail')
        },
        {
          path: 'addJudgeToJudges',
          name: 'addJudgeToJudges',
          hidden: true,
          meta: { title: '添加评委', hiddenNav: true, level: 6, nav: 'act' },
          component: () =>
            import('@/views/compmanage/peopleManage/sub/judge/add-judge')
        },
        {
          path: 'addJudgeFromNations/:id',
          name: 'addJudgeFromNations',
          hidden: true,
          meta: { title: '添加评委', hiddenNav: true, level: 6, nav: 'act' },
          component: () =>
            import(
              '@/views/compmanage/peopleManage/sub/judge/add-judge/nationsAdd.vue'
            )
        },
        {
          path: 'judgeDetail/:id',
          name: '评委详情',
          hidden: true,
          meta: { title: '评委详情', hiddenNav: true, level: 6, nav: 'act' },
          component: () =>
            import('@/views/compmanage/peopleManage/judge-detail')
        }
      ]
    },
    {
      path: '/reportResult/:id',
      name: '上报结果',
      component: () => import('@/views/compmanage/report-result')
    },
    // 推荐活动的结果上报
    {
      path: '/enrollOfRecommend/:id',
      name: '相关材料上报(推荐)',
      hidden: true,
      meta: { title: '相关材料上报(推荐)', level: 3, nav: 'act' },
      component: resolve =>
        require(['@/views/compmanage/activity/enroll/index2.vue'], m =>
          resolve(m.default))
    },
    {
      path: '/addPlayer',
      name: 'addPlayer',
      meta: {
        title: '添加参赛选手',
        level: 4,
        nav: 'act'
      },
      component: () =>
        import('@/views/compmanage/activity/enroll/AddPlayer.vue')
    },
    {
      path: '/addPlayerDetail',
      name: 'addPlayerDetail',
      meta: {
        title: '选手详情',
        level: 4,
        nav: 'act'
      },
      component: () =>
        import('@/views/compmanage/activity/enroll/AddPlayerDetail.vue')
    },
    {
      path: '/activityImages/:id',
      name: '上传图片',
      meta: {
        title: '上传图片',
        level: 4,
        nav: 'act'
      },
      component: () => import('@/views/compmanage/activityImages')
    },
    {
      path: '/actInfors',
      name: 'actInfors',
      component: () => import('@/views/activityInformation/infors'),
      meta: {
        title: '资讯列表',
        level: 2,
        nav: 'act'
      }
    },
    {
      path: '/inforDetail/:id',
      name: 'inforDetail',
      component: () => import('@/views/activityInformation/inforDetail'),
      meta: {
        title: '资讯详情',
        level: 3,
        nav: 'act'
      }
    },
    {
      path: '/addInfor',
      name: 'addInfor',
      component: () => import('@/views/activityInformation/addInfor'),
      meta: {
        title: '资讯撰写',
        level: 3,
        nav: 'act'
      }
    },
    {
      path: '/webpageSetting/:id',
      name: 'webpageSetting',
      component: () => import('@/views/webpageSetting'),
      meta: {
        title: 'H5宣传页',
        level: 3,
        nav: 'act'
      },
      children: [
        {
          path: '/webpageDataModule/:id',
          name: 'webpageDataModule',
          hidden: true,
          meta: { title: 'H5宣传页', level: 3, nav: 'act' },
          component: () => import('@/views/webpageSetting/DataModule')
        },
        {
          path: '/webpageContentEdit/:id',
          name: 'webpageContentEdit',
          hidden: true,
          meta: { title: 'H5宣传页', level: 3, nav: 'act' },
          component: () => import('@/views/webpageSetting/ContentEdit')
        },
        {
          path: '/webpagePosters/:id',
          name: 'webpagePosters',
          hidden: true,
          meta: { title: 'H5宣传页', level: 3, nav: 'act' },
          component: () => import('@/views/webpageSetting/PosterEdit')
        },
        {
          path: '/webpageMusic/:id',
          name: 'webpageMusic',
          hidden: true,
          meta: { title: 'H5宣传页', level: 3, nav: 'act' },
          component: () => import('@/views/webpageSetting/MusicEdit')
        },
        {
          path: '/webpageResult/:id',
          name: 'webpageResult',
          hidden: true,
          meta: { title: 'H5宣传页', level: 3, nav: 'act' },
          component: () => import('@/views/webpageSetting/ResultEdit')
        }
      ]
    },
    {
      path: '/webpagePreview/:id',
      name: 'H5页面预览',
      hidden: true,
      meta: { title: 'H5页面预览', level: 4, nav: 'act' },
      component: () => import('@/views/webpageSetting/WebpagePreview')
    },
    {
      path: '/datavisualization/:id',
      name: 'datavisualization',
      hidden: true,
      meta: { title: '数据可视化', level: 2, nav: 'act' },
      component: () => import('@/views/datavisualization/index.vue')
    },
    {
      path: '/datavisualizationDetail',
      name: 'datavisualizationDetail',
      hidden: true,
      meta: { title: '上报详情', level: 3, nav: 'act' },
      component: () => import('@/views/datavisualization/detail.vue')
    },
    {
      path: '/dataReport',
      name: 'dataReport',
      hidden: true,
      meta: { title: '数据上报', level: 3, nav: 'act' },
      component: () => import('@/views/compmanage/dataReport/edit.vue')
    },
    {
      path: '/judgesToSignUpInfo',
      name: 'index',
      component: () => import('@/views/GroupApply/JudgesToSignUpInfo.vue')
    },
    {
      path: '/judgesToDeclare/index',
      name: 'index',
      component: () => import('@/views/judgesToDeclare/SingleApply.vue')
    },
    {
      path: '/judgesToDeclare/edit',
      name: 'index',
      component: () => import('@/views/judgesToDeclareEdit/SingleApply.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/router-compmanage.js